import { Avatar } from '@/components/ui/avatar'
import { Typography } from '@/components/ui/typography'
import { getAssetLink } from '@/helpers/get-asset-link'
import { Building } from '@/reducers/types'

import { NameCell } from '../../shared/person-name-cell/person-name-cell.styled'
import { getPlaceName } from '../places.utils'

interface PlaceNameCellProps {
  building: Building
}

export const PlaceNameCell = ({ building }: PlaceNameCellProps) => (
  <NameCell>
    <Avatar
      shape="square"
      size="small"
      src={getAssetLink({ file: building.logo ?? undefined, path: 'chitown-building' })}
    />
    <div>
      <Typography color="black800" size="text-small" weight="medium" breakLines={1}>
        {getPlaceName(building)}
      </Typography>
      {building.code && (
        <Typography color="black500" size="text-small" weight="medium" breakLines={1}>
          {building.code}
        </Typography>
      )}
    </div>
  </NameCell>
)
